import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import '../../css/clydeNotificationMessage.css';
var ClydeNotificationMessage = function (_a) {
    var _b;
    var clickAction = _a.clickAction, fadeOnClick = _a.fadeOnClick, text = _a.text, timeout = _a.timeout, type = _a.type, className = _a.className;
    var _c = useState({}), transitionStyle = _c[0], setTransitionStyle = _c[1];
    var _d = useState(0), loadStylePercent = _d[0], setLoadStylePercent = _d[1];
    var _e = useState({
        width: '0%',
        transition: '8000ms ease',
    }), loadStyle = _e[0], setLoadStyle = _e[1];
    var isTimedOut = loadStylePercent <= 100;
    useEffect(function () {
        if (timeout && isTimedOut) {
            setLoadStylePercent(loadStylePercent + 100);
            setLoadStyle({
                transition: '7000ms ease',
                width: "".concat(loadStylePercent, "%"),
            });
        }
        if (!isTimedOut) {
            setTimeout(function () {
                setTransitionStyle({
                    transition: '1500ms ease',
                    opacity: 0,
                });
            }, 7000);
            setTimeout(function () { return setTransitionStyle({ display: 'none' }); }, 8500);
        }
    }, [timeout, isTimedOut, loadStylePercent]);
    var handleClick = function () {
        if (clickAction) {
            clickAction();
        }
        if (fadeOnClick) {
            setTransitionStyle({
                transition: '2500ms ease',
                opacity: 0,
            });
            setTimeout(function () { return setTransitionStyle({ display: 'none' }); }, 3000);
        }
    };
    var _notificationMessageContainerClass = classNames('clyde-notification-message-container', (_b = {
            'clyde-notification-message-container--fade-on-click': fadeOnClick,
            'clyde-notification-message-container--success': type === 'success',
            'clyde-notification-message-container--alert': type === 'alert',
            'clyde-notification-message-container--action': clickAction,
            'clyde-notification-message-container--success--action': clickAction && type === 'success',
            'clyde-notification-message-container--alert--action': clickAction && type === 'alert'
        },
        _b[String(className)] = className,
        _b));
    var _notificationLoaderClass = "clyde-notification-message-loading clyde-notification-message-loading--".concat(type);
    var _notificationMessageTypeClass = "clyde-notification-message-type clyde-notification-message-type--".concat(type);
    var _notificationMessageActionClass = "clyde-notification-message-action clyde-notification-message-action--".concat(type);
    return (React.createElement("div", { className: _notificationMessageContainerClass, style: transitionStyle, onClick: handleClick },
        React.createElement("div", { className: _notificationLoaderClass, style: loadStyle }),
        React.createElement("div", { className: _notificationMessageTypeClass }),
        React.createElement("div", { className: 'clyde-notification-message-text' }, text),
        clickAction
            ? React.createElement("div", { className: _notificationMessageActionClass })
            : null));
};
export default ClydeNotificationMessage;
